// frontend/src/components/common/ThemeToggle.jsx
import { useTheme } from "../../context/ThemeContext";
import { MoonIcon, SunIcon } from "./Icon";
import "./ThemeToggle.css";

/** Icon button that flips between dark and light themes. size: sm | md */
export default function ThemeToggle({ className = "", size = "md" }) {
  const { isDark, toggleTheme } = useTheme();
  const label = isDark ? "Switch to light theme" : "Switch to dark theme";

  return (
    <button
      type="button"
      className={`theme-toggle theme-toggle--${size} ${className}`.trim()}
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      <span className={`theme-toggle__icon${isDark ? " is-active" : ""}`}>
        <SunIcon size={17} />
      </span>
      <span className={`theme-toggle__icon${!isDark ? " is-active" : ""}`}>
        <MoonIcon size={16} />
      </span>
    </button>
  );
}
